module.exports = __webpack_public_path__ + "img/241226s.2c4a3389.jpg";